import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function PaymentTerms() {
  const { language } = useLanguage();

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="payment-terms-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#1B3A7B] hover:underline mb-6">
        <ChevronLeft className="w-4 h-4" />
        {language === 'pl' ? 'Powrot do kalkulatora' : 'Back to calculator'}
      </Link>

      <h1 className="text-3xl sm:text-4xl font-heading font-bold text-[#1B3A7B] mb-8">
        {language === 'pl' ? 'Regulamin Platnosci' : 'Payment Terms'}
      </h1>

      <div className="prose prose-slate max-w-none space-y-6 text-sm leading-relaxed text-slate-700">
        <p className="text-slate-500 text-xs">Obowiazuje od: 15 lutego 2026 r.</p>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">1. Postanowienia ogolne</h2>
          <p>1.1. Niniejszy Regulamin Platnosci okresla zasady rozliczen za uslugi ksiegowe swiadczone przez <strong>Biuro Rachunkowe Kurdynowski</strong> (dalej: &bdquo;Uslugodawca&rdquo;).</p>
          <p>1.2. Regulamin stanowi integralna czesc umowy o swiadczenie uslug ksiegowych.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">2. Wycena uslug</h2>
          <p>2.1. Wycena generowana przez kalkulator dostepny w Serwisie ma charakter orientacyjny.</p>
          <p>2.2. Ostateczna cena uslug ustalana jest indywidualnie w ramach umowy miedzy Uslugodawca a Klientem.</p>
          <p>2.3. Ceny podane w kalkulatorze sa cenami netto (bez podatku VAT).</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">3. Warunki platnosci</h2>
          <p>3.1. Platnosc za uslugi ksiegowe odbywa sie na podstawie faktury VAT wystawionej przez Uslugodawce.</p>
          <p>3.2. Termin platnosci wynosi 14 dni od daty wystawienia faktury, chyba ze umowa stanowi inaczej.</p>
          <p>3.3. Akceptowane formy platnosci:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Przelew bankowy na rachunek wskazany na fakturze</li>
            <li>Inne formy platnosci ustalone indywidualnie z Uslugodawca</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">4. Rozliczenia miesieczne</h2>
          <p>4.1. Uslugi ksiegowe rozliczane sa w cyklach miesiecznych.</p>
          <p>4.2. Faktura za dany miesiac wystawiana jest do 10. dnia miesiaca nastepnego.</p>
          <p>4.3. W przypadku zmiany zakresu uslug w trakcie miesiaca, rozliczenie zostanie proporcjonalnie skorygowane.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">5. Opoznienia w platnosci</h2>
          <p>5.1. W przypadku opoznienia w platnosci Uslugodawca zastrzega sobie prawo do naliczenia odsetek ustawowych za opoznienie.</p>
          <p>5.2. W przypadku opoznienia przekraczajacego 30 dni Uslugodawca ma prawo do wstrzymania swiadczenia uslug do czasu uregulowania naleznosci.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">6. Zmiana cennika</h2>
          <p>6.1. Uslugodawca zastrzega sobie prawo do zmiany cennika uslug.</p>
          <p>6.2. O zmianach cennika Klient zostanie poinformowany z co najmniej 30-dniowym wyprzedzeniem.</p>
          <p>6.3. Klient ma prawo do wypowiedzenia umowy w przypadku braku akceptacji nowego cennika.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">7. Zwroty</h2>
          <p>7.1. W przypadku nadplaty, nadwyzka zostanie zaliczona na poczet kolejnej faktury lub zwrocona na wniosek Klienta.</p>
          <p>7.2. Zwrot srodkow nastepuje w terminie 14 dni na rachunek bankowy Klienta.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">8. Kontakt</h2>
          <p>W sprawach zwiazanych z platnosciami prosimy o kontakt: <a href="mailto:monika.gawkowska@kurdynowski.pl" className="text-[#1B3A7B] hover:underline">monika.gawkowska@kurdynowski.pl</a></p>
        </section>
      </div>
    </div>
  );
}
